import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect, select } from "redux-saga/effects";
import createAccount from "../account/create";
import api from "../../../settings/api";
import { clearString, getFormattedCart } from "../../../utils/functions";
import { avulsoFlAceiteAdesaoTag } from "../../../utils/flAceiteAdesaoTag";
import { ReducersTypes } from "../../reducers/Models";

export interface PixCallbackData {
  pixCode: string;
  codeExpiration: string;
  pixImage: string;
  pixImageType: string;
  pixImageWidth: number;
  idTransaction?: string;
  sqPagamento?: string;
  plate?: string;
  total?: number;
}

export interface Fetch {
  plate: string;
  document: string;
  name: string;
  email: string;
  phone: string;
  address: {
    zipcode: string;
    streetName: string;
    neighborhood: string;
    addressStreet: string;
    number: string;
    complement: string;
    city: string;
    state: string;
    stateCode: string;
  };
  callback: (
    success: boolean,
    code?: PixCallbackData | { errorCode: string },
  ) => void;
}

export interface PaymentPixAction {
  type: string;
  payload: Fetch;
}

export default function* paymentPix({
  payload,
}: PaymentPixAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    // @ts-expect-error
    const user: ReducersTypes["userReducer"] = yield select(
      (state: ReducersTypes) => state.userReducer,
    );
    const nrc = user?.nrc;
    const accountId = user?.accountId;

    // Se tiver nrc e accountId (fluxo zapay), usa diretamente sem criar conta
    let account: { customerId: string; accountId: string } | unknown;

    if (nrc && accountId) {
      account = {
        customerId: nrc,
        accountId: accountId,
      };
    } else {
      account = yield call(createAccount, {
        type: "",
        payload: {
          document: payload.document,
          name: payload.name,
          email: payload.email,
          phone: payload.phone,
          licensePlate: payload.plate,
        },
      });

      if (!account) throw new Error();
    }

    const { total, selected } = getFormattedCart({
      // @ts-expect-error sagas types
      debts: payload?.debts,
      // @ts-expect-error sagas types
      cart: payload?.cart,
    });

    const body = {
      // @ts-expect-error sagas types
      requestId: payload?.requestId,
      // @ts-expect-error sagas types
      customerIdentification: account?.customerId,
      // @ts-expect-error sagas types
      accountIdentification: account?.accountId,
      paymentValue: Number(Number(total)?.toFixed(2)),
      licensePlate: clearString(payload.plate.toLocaleUpperCase()),
      tollPassages: selected,
      email: payload.email || "",
      phoneNumber: payload.phone ? clearString(payload.phone) : "",
      flAceiteAdesaoTag: avulsoFlAceiteAdesaoTag(user?.flAceiteAdesaoTag),
    };

    const response = yield call(api.post, `/v1/payments/pix`, body);

    // Check if response has error code 422 even with status 200
    if (response?.data?.errorCode === "422") {
      yield call(payload.callback, false, { errorCode: "422" });
      return;
    }

    if (response?.data?.textContent) {
      yield call(payload.callback, true, {
        pixCode: response?.data?.textContent,
        codeExpiration: response?.data?.expirationDate,
        pixImage: response?.data?.generateImage?.imageContent,
        pixImageType: response?.data?.generateImage?.mimeType,
        pixImageWidth: response?.data?.generateImage?.actualImageWidth,
        idTransaction: response?.data?.idTransaction,
        sqPagamento: response?.data?.sqPagamento,
        plate: payload.plate,
        total: total,
      });
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
